<template>
    <div class="group-news app">
        <div class="header-empty"></div>
        <div class="main-content">
            <breadItem :title1="breadTitle1" :title2="breadTitle2" :link1="breadLink1" :link2="breadLink2"></breadItem>
            <div class="doctor-box">
                <div class="doctor-img">
                    <div class="img-box clearfix">
                        <div class="img-left wh120 fl">
                            <img :src="data.img" :alt="data.name" class="img-responsive">
                        </div>
                        <div class="img-out fl">
                            <div class="color-blank fs18 fwb name">{{data.name}}</div>
                            <div class="color-blank fs14 job-title">{{data.position}}</div>
                            <div class="color-gray fs14 depart">{{data.department}}</div>
                        </div>
                    </div>
                    <div class="img-reverve" @click="goReverve" v-if="data.allow_appointment==1">
                        <img src="../../assets/images/reserve.png" alt="" class="reserve-icon mr10">
                        <span class="tips fs18 fwb color-blue">预约</span>
                    </div>
                </div>
                <div class="quill-editor">
                    <div class="ql-container ql-snow">
                        <div class="ql-editor doctor-detail pre-wrap" v-html="data.content"></div>
                    </div>
                </div>
            </div>
            <nav-top></nav-top>
        </div>
    </div>
</template>

<script>
import navTop from '@/components/top'
import breadItem from '@/components/breadItem'
export default {
    data() {
        return {
            data:'',
            name:this.$route.params.class,
            breadTitle1:'医生集团',
            breadTitle2: this.$route.params.class,
            breadLink1:'/doctorGroup/0.html',
            breadLink2:'/doctorGroup/'+ this.$route.params.categoryId +'.html'
        };
    },
    computed: {

    },
    created() {
        this.getDetail();
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        goReverve:function(){
            this.$router.push('/doctorGroupReserve/'+this.$route.params.categoryId+'/'+this.$route.params.id+'/'+this.$route.params.class+'/'+this.data.hospital_id+'/'+this.data.sub_hospital_id+'/'+this.data.branch_id+'/'+this.data.name+'/'+this.data.hospital_name+'.html');
        },
        getDetail:function(){
            this.$axios.post(this.api.doctorGroup.detail,{id:this.$route.params.id},res =>{
                this.data=res.data;
            },err =>{
                this.data='';
            });
        }
    },
    components: {
        navTop,
        breadItem
    },
};
</script>

<style scoped>
    .doctor-box{padding:40px;box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;}
    .doctor-img{position: relative;margin-bottom:40px;}
    .doctor-img .img-left{border-radius:50%;overflow: hidden;margin-right:20px;}
    .doctor-img .img-reverve{position:absolute;top:50%;right:0;margin-top:-20px;width:100px;height:40px;border-radius:5px;border:1px solid rgba(13,52,130,1);text-align: center;}
    .doctor-img .tips{height:38px;line-height:38px;vertical-align: middle;}
    .doctor-detail{margin-top:40px;}
    .img-out{padding-top:18px;}
    .img-out .name{line-height:25px;}
    .img-out .job-title{line-height:20px;margin:10px 0;}
    .img-out .depart{line-height:20px;}
    .app .go-top{
        right:0;
        bottom:0px;
    }
</style>
<style>
.doctor-box .doctor-detail a{text-decoration: underline;color:rgb(0, 0, 238);}
</style>



// WEBPACK FOOTER //
// src/view/doctors/detail.vue